import { render, staticRenderFns } from "./BookAppointmentServices.vue?vue&type=template&id=5906d671&"
import script from "./BookAppointmentServices.vue?vue&type=script&lang=js&"
export * from "./BookAppointmentServices.vue?vue&type=script&lang=js&"
import style0 from "./BookAppointmentServices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports